import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';

import { GlobalComponent } from 'src/app/global/global.component';
import { ManageServiceBO } from '../manage-service.modal';

@Injectable({
  providedIn: 'root'
})

export class ServiceDataservice extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  public execute(state: ManageServiceBO): void {
    this.getService(state).subscribe(x => super.next(x));
  }
  getService(state?: ManageServiceBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Service/GetServiceList?", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))


  }
}
